import React from 'react';
import PropTypes from 'prop-types';
import LoadingOverlay from 'react-loading-overlay';
import ClipLoader from "react-spinners/ClipLoader";

const wrapperStyle = {
  position: 'relative',
};

// react-loading-overlay ships broken propTypes for `styles` in React 17+
LoadingOverlay.propTypes = undefined;

const Loader = ({ loading = true, children }) => {
  return (
    <div style={wrapperStyle}>
      {loading ? (
        <LoadingOverlay active={loading} spinner={<ClipLoader color={'#2D831F'} />} text="Loading..." />
      ) : (
        children
      )}
    </div>
  );
};

Loader.propTypes = {
  children: PropTypes.node.isRequired,
  loading: PropTypes.bool,
};

export default Loader;
